<template>
    <div v-if="dados.settings && selectedPlano && adicionais.length">
        <div class="pricing-table">
            <vue-slick-carousel v-bind="[dados.settings, settings]">
                <template #prevArrow="arrowOption">
                    <div class="custom-arrow" :style="($route=='confirmar-plano')?'left:-1.5rem':'left:-1rem;'">
                        {{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}
                    </div>
                </template>
                <template #nextArrow="arrowOption">
                    <div class="custom-arrow" :style="($route=='confirmar-plano')?'right:-0.3rem;':'right:0rem;'">
                        {{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}
                    </div>
                </template>
                <template v-for="(item, i) in adicionais">
                    <div :key="item.id" class="pricing-item col-11 p-0 mx-0">
                        <div class="pricing-title pt-3 pb-5"
                            :style="`background: rgb(${40-(i*5)}, ${130-(i*13)}, ${200-(i*20)})`">
                            <p><i :class="'fa fa-2x'+item.icon"></i></p>
                            {{ title(item.title) }}
                        </div>
                        <div class="pricing-value py-3">
                            <span class="moneytext">R$</span>
                            {{ formatMoney(item.valor).substr(3) }}
                        </div>
                        <ul v-if="(item.options).length" class="pricing-features">
                            <li v-for="(option, o) in item.options" :key="o">
                                <span>{{ option }}</span>
                            </li>
                        </ul>
                        <label>Incluir</label>
                        <div class="row mb-3 mx-auto w-75 justify-content-around">
                            <div @click="addPlus(item,1)" class="btn btn-default">+1</div>
                            <div @click="addPlus(item,10)" class="btn btn-default">+10</div>
                            <div @click="addPlus(item,50)" class="btn btn-default">+50</div>
                        </div>
                    </div>
                </template>
            </vue-slick-carousel>
        </div>
    </div>
</template>

<script>
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    import VueSlickCarousel from 'vue-slick-carousel';
    export default {
        props: ['dados', 'selectedPlano'],
        data() {
            return {
                settings: {
                    slidesToShow: 2,
                }
            }
        },
        components: {
            VueSlickCarousel,
        },
        beforeMount() {

        },
        computed: {
            adicionais() {
                return this.$store.state.plano.adicionais;
            },
        },
        methods: {
            title(payload) {
                switch (payload) {
                    case 'Acesso/Usuário':
                        return 'Acrescente mais usuários na opção da Plataforma'
                    case 'Upload/Arquivo':
                        return 'Acrescentar novos Uploads na Plataforma'
                    default:
                        return payload;
                }
            },
            addPlus(payload, value) {
                let alreadyAdd = this.dados.selected.adicionais.findIndex(x => x.id == payload.id);
                if (alreadyAdd > -1) {
                    this.dados.selected.adicionais[alreadyAdd].quantidade += value;
                } else {
                    payload.quantidade = value;
                    let adicional = {
                        id: payload.id,
                        quantidade: value,
                        title: payload.title,
                        valor: parseFloat(payload.valor)
                    }
                    this.dados.selected.adicionais.push(adicional);
                }
            }
        }
    }
</script>

<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped src="@/assets/sass/home.css"></style>
<style scoped lang="scss" src="./register.scss"></style>